// extracted by mini-css-extract-plugin
export var bio = "MedicalAdvisor-module__bio___cgQVP";
export var container = "MedicalAdvisor-module__container___qw6S7";
export var content = "MedicalAdvisor-module__content___LWeyh";
export var img = "MedicalAdvisor-module__img___tUb5E";
export var right = "MedicalAdvisor-module__right___Fb695";
export var title = "MedicalAdvisor-module__title___mpp2y";